import React from 'react';
import Modal from '../components/Modal';
import api from '../api';
import SearchInput from '../components/SearchInput';
import ClientPreview from '../components/clients/ClientPreview';

class SelectedMergeToClient extends React.Component {
    render() {
        var {primaryClient}  = this.props;
        if(! Object.keys(primaryClient).length) return null;

        return (
            <div className="row">
                <div className="col-md-12">
                    <div className={'panel panel-default'} style={{marginBottom: '0px'}}>
                        <ClientPreview onPageClientId={this.props.onPageClientId} staff={this.props.staff} client={this.props.primaryClient} />
                    </div>
                </div>
            </div>
        );
    }
}

var addResolvedProperty = (matchingClients) => {
    if(! matchingClients.length) return [];

    var clientsWithResolvedProperty = matchingClients.map(client => Object.assign(client, {resolvesClient: false}));
    if(clientsWithResolvedProperty.length == 1) {
        clientsWithResolvedProperty[0].resolvesClient = true;
    } else {
        // use algo to add it
    }
    return matchingClients;
};

export default class MergeClientsModal extends React.Component {
    constructor(props) {
        super(props);

        var matchingSearch = props.client.name.replace(" Ltd.", "");
        var matchingSearch = matchingSearch.replace(/(\bPty\b)|(\bLtd\b)/gi, "");

        this.state = {
            isSaving: false,
            matchingClients: [],
            clientsMatchingPrimaryClientSearch : [],
            primaryClient: props.client,
            matchingClientSearchText: matchingSearch.trim(),
            primaryClientSearchText: props.client.name.trim()
        };
        this.hasPrimaryClient = this.hasPrimaryClient.bind(this);
        this.hasResolved = this.hasResolved.bind(this);
        this.getMatchingClients = this.getMatchingClients.bind(this);
    }
    componentDidMount() {
        this.getMatchingClients(this.props.client.name);
        // if client is company then use company as client to merge into, no need to search
        this.handleOnPrimaryClientSearch(this.props.client.name);
    }
    getMatchingClients(searchText) {
        api.post('clients/search', {showDuds: true, showFullResult: true, page: 1, limit: 5, searchText: searchText}).then(res => {
            var matchingClients = res.value.clients;

            this.setState({matchingClients: addResolvedProperty(matchingClients)});
        });
    }
    getMatchingPublicId(publicId) {
        api.post('client_with_public_id', {publicId}).then(res => {
            var matchingClient = res.value;
            if(matchingClient != 'Not found') {
                this.setState({matchingClients: addResolvedProperty([matchingClient])});
            }
        });
    }
    hasPrimaryClient() {
        return Object.keys(this.state.primaryClient).length > 0;
    }
    hasResolved() {
        return !! this.state.matchingClients.find(c => c.resolvesClient == true);
    }
    mergeClients() {
        this.setState({isSaving: true});
        var mergeFromClient = this.state.matchingClients.find(c => c.resolvesClient == true);
        var mergeFromClientId = this.state.matchingClients.find(c => c.resolvesClient == true).id;
        var mergeToClientId = this.state.primaryClient.id;

        if(mergeFromClientId == mergeToClientId) {
            alert('Master client and dud/dupe client must be different');
            return;
        }

        if (! this.state.primaryClient.fergusId && mergeFromClient.fergusId){
            alert("The dud client has a fergus account and the primary account doesn't.");
        }

        if(mergeFromClientId == mergeToClientId) {
            alert('Master client and dud/dupe client must be different');
            return;
        }

        var request = {mergeFromClientId, mergeToClientId};
        api.post('clients/merge', request).then(res => {

            var primaryClientId = res.value.primaryClientId;
            // lets just refresh for now so we get all the merged contacts and events
            // @todo close modal and dispatch load active client events
            window.location.href = `/clients/${primaryClientId}`;
        });
    }
    handleOnPrimaryClientSearch(searchText) {
        api.post('/clients/search', {showFullResult: true, limit: 5, page: 1, searchText: searchText}).then(res => {
            this.setState({clientsMatchingPrimaryClientSearch: res.value.clients});
        });
    }
    handleOnMatchingClientSearch(searchText) {
        var wantsToSearchPublicId = Number.isInteger(+searchText) && searchText.toString().length == 4;
        if(wantsToSearchPublicId) {
            this.getMatchingPublicId(searchText);
        } else {
            this.getMatchingClients(searchText);
        }
    }
    makePrimaryClient(primaryClient) {
        this.setState({primaryClient});
    }
    removePrimaryClient(e) {
        e.preventDefault();
        api.post('/clients/search', {page: 1, showFullResult: true, limit: 5, searchText: this.state.primaryClientSearchText}).then(res => {
            this.setState({primaryClient: {}, clientsMatchingPrimaryClientSearch: res.value.clients});
        });
    }
    toggleResolvesMatchingClient(clientId) {
        var matchingClients = this.state.matchingClients;
        var client = matchingClients.find(c => c.id == clientId);
        client.resolvesClient = ! client.resolvesClient;

        // make any that have client.resolvesClient true and not clientId to be client.resolvesClient false
        var matchingClients = matchingClients.map(c => {
            if(c.id != clientId && c.resolvesClient == true) {
                return {...c, resolvesClient: false};
            }
            return c;
        });

        this.setState({matchingClients});
    }
    render() {
        var mergeModal = this.hasPrimaryClient() && this.state.matchingClients.filter(c => c.resolvesClient).length ?
            (<button className="btn btn-success" onClick={this.mergeClients.bind(this)}>Merge</button>) :
            (<button className="btn btn-success disabled">Merge</button>);

        var actionButton = this.state.isSaving ?
            (<button className="btn btn-success disabled">Saving...</button>) :
            mergeModal;

        return (
            <Modal actionButton={actionButton} className="modal-success" title={"Merge Clients"}>
                <div ref="noteContainer" className='modal-body'>
                    <h1 style={{marginTop: '0px', marginBottom: '25px'}}>
                        <span style={{marginRight: '10px', backgroundColor: '#2A2C36', borderRadius: '20px', padding: '6px 13px', fontSize: '22px'}} className="label label-success">1</span>
                        {! this.hasPrimaryClient() &&
                        <span>Choose a master client to merge into</span>
                        }
                        {this.hasPrimaryClient() &&
                        [
                            <span>Master Client to merge into </span>,
                            (<a href="#" onClick={this.removePrimaryClient.bind(this)}>(change)</a>)
                        ]
                        }
                    </h1>

                    {! this.hasPrimaryClient() &&
                    <SearchInput placeholder="Search for Master Client to merge into"
                                 searchText={this.state.primaryClientSearchText}
                                 onSearch={this.handleOnPrimaryClientSearch.bind(this)} />
                    }

                    {! this.hasPrimaryClient() &&
                    <div style={{marginTop: '20px'}}>
                        {this.state.clientsMatchingPrimaryClientSearch.map(c => {
                            return (
                                <div className="row" key={c.id}>                                    
                                    <div className="col-md-1">
                                        <button onClick={this.makePrimaryClient.bind(this, c)} className={'btn btn-default'}>
                                            <i className="fa fa-check"></i>
                                        </button>
                                    </div>
                                    <div className="col-md-11">
                                        <div className={'panel panel-default'}>                                        
                                            <ClientPreview onPageClientId={this.props.client.id} client={c} staff={this.props.staff} />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    }

                    <SelectedMergeToClient onPageClientId={this.props.client.id} staff={this.props.staff} primaryClient={this.state.primaryClient} />

                    <hr />

                    <h1 style={{marginBottom: '20px'}}>
                        <span style={{marginRight: '10px', backgroundColor: '#2A2C36', borderRadius: '20px', padding: '6px 13px', fontSize: '22px'}} className="label label-success">2</span>
                        Choose a dud or dupe client to merge from
                    </h1>
                    <SearchInput placeholder="Search for the dud or dupe client to merge from" searchText={this.state.matchingClientSearchText} onSearch={this.handleOnMatchingClientSearch.bind(this)} />
                    <div style={{marginTop: '20px'}}>
                        {this.state.matchingClients.map(c => {
                            if (c.id == this.state.primaryClient.id){
                                return null;
                            }
                            return (
                                <div className="row" key={c.id}>
                                    <div className="col-md-1">
                                        <button onClick={this.toggleResolvesMatchingClient.bind(this, c.id)} className={c.resolvesClient ? 'btn btn-success' : 'btn btn-default'}>
                                            <i className="fa fa-check"></i>
                                        </button>
                                    </div>
                                    <div className="col-md-11">
                                        <div className={c.resolvesClient ? 'panel panel-success' : 'panel panel-default'}>                                            
                                            <ClientPreview onPageClientId={this.props.client.id} client={c} staff={this.props.staff} />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/MergeClientsModal.js